import * as yup from 'yup'; 
import api from '@/services/api';

export const myProfileSchema = yup.object({
  email: yup.string()
  .required('Username es requerido')
  .email('Correo electrónico inválido')
  .test('checkDuplicateUsername',
        'El Username ya existe',
        async function (value) {
          const { id } = this.options.context || {};
          if (!value) return true; // Skip if empty — let `.required` handle it
  
          try {
            const response = await api.get(`/user/validate-username?id=${id}&username=${value}`);
  
            return !response.data; 
          } catch (error) {
            return this.createError({
              message: 'Error al validar el nombre de usuario',
            });
          }
        }
      ),
  firstName: yup.string().required('Nombre es requerido'),
  lastName: yup.string().required('Apellido es requerido')
});